/* Parts4Cars chat asistent — rule-based, bez externí služby */
(function () {
  const root = document.querySelector('[data-chat-widget]');
  if (!root) return;

  const toggleBtns = root.querySelectorAll('[data-chat-toggle]');
  const panel = root.querySelector('[data-chat-panel]');
  const bubble = root.querySelector('.chat-widget__bubble');
  const messagesEl = root.querySelector('[data-chat-messages]');
  const chipsEl = root.querySelector('[data-chat-chips]');
  const form = root.querySelector('[data-chat-form]');
  const input = root.querySelector('[data-chat-input]');
  const configEl = root.querySelector('[data-chat-config]');
  if (!panel || !messagesEl || !configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  // Shopify `t` filtr escapuje HTML entity v překladech — dekóduj zpět na text
  const ta = document.createElement('textarea');
  function decodeEntities(s) {
    ta.innerHTML = s;
    return ta.value;
  }
  config.greeting = decodeEntities(config.greeting);
  config.fallback = decodeEntities(config.fallback);
  config.topics.forEach((t) => {
    t.chip = decodeEntities(t.chip);
    t.answer = decodeEntities(t.answer);
    t.link_label = decodeEntities(t.link_label);
  });

  let opened = false;
  let greeted = false;

  function normalize(s) {
    return s
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  function addMessage(text, who, link, linkLabel) {
    const li = document.createElement('div');
    li.className = 'chat-widget__msg chat-widget__msg--' + who;
    const bubbleEl = document.createElement('div');
    bubbleEl.className = 'chat-widget__msg-bubble';
    bubbleEl.textContent = text;
    if (link && linkLabel) {
      const a = document.createElement('a');
      a.className = 'chat-widget__msg-link';
      a.href = link;
      a.textContent = linkLabel + ' →';
      bubbleEl.appendChild(a);
    }
    li.appendChild(bubbleEl);
    messagesEl.appendChild(li);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return li;
  }

  function typing() {
    const li = document.createElement('div');
    li.className = 'chat-widget__msg chat-widget__msg--bot';
    li.innerHTML =
      '<div class="chat-widget__msg-bubble chat-widget__typing"><span></span><span></span><span></span></div>';
    messagesEl.appendChild(li);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return li;
  }

  function botReply(topic) {
    const t = typing();
    setTimeout(() => {
      t.remove();
      if (topic) addMessage(topic.answer, 'bot', topic.link, topic.link_label);
      else addMessage(config.fallback, 'bot');
      renderChips();
    }, 550 + Math.random() * 350);
  }

  function matchTopic(text) {
    const n = normalize(text);
    let best = null;
    let bestScore = 0;
    config.topics.forEach((topic) => {
      const kws = normalize(topic.keywords).split(/[,;]+/).map((k) => k.trim()).filter(Boolean);
      let score = 0;
      kws.forEach((k) => {
        if (k && n.includes(k)) score += k.length;
      });
      if (score > bestScore) {
        bestScore = score;
        best = topic;
      }
    });
    return best;
  }

  function renderChips() {
    chipsEl.innerHTML = '';
    config.topics.forEach((topic) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'chat-widget__chip';
      b.textContent = topic.chip;
      b.addEventListener('click', () => {
        addMessage(topic.chip, 'user');
        chipsEl.innerHTML = '';
        botReply(topic);
      });
      chipsEl.appendChild(b);
    });
  }

  function open() {
    opened = true;
    panel.hidden = false;
    root.classList.add('is-open');
    toggleBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
    if (!greeted) {
      greeted = true;
      const t = typing();
      setTimeout(() => {
        t.remove();
        addMessage(config.greeting, 'bot');
        renderChips();
      }, 600);
    }
    if (input && window.matchMedia('(min-width: 640px)').matches) input.focus();
  }

  function close() {
    opened = false;
    root.classList.remove('is-open');
    toggleBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => {
      if (!opened) panel.hidden = true;
    }, 250);
  }

  toggleBtns.forEach((b) => b.addEventListener('click', () => (opened ? close() : open())));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && opened) close();
  });

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const val = (input.value || '').trim();
      if (!val) return;
      addMessage(val, 'user');
      input.value = '';
      chipsEl.innerHTML = '';
      botReply(matchTopic(val));
    });
  }

  // jemné upozornění po chvíli nečinnosti (jen jednou za session)
  try {
    if (!sessionStorage.getItem('p4c-chat-pinged')) {
      setTimeout(() => {
        if (!opened) bubble.classList.add('has-ping');
        sessionStorage.setItem('p4c-chat-pinged', '1');
      }, 6000);
    }
  } catch (e) { /* private mode */ }
  bubble.addEventListener('click', () => bubble.classList.remove('has-ping'));
})();
